import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CardTitleWithIconProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  iconClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

const CardTitleWithIcon: React.FC<CardTitleWithIconProps> = ({
  icon: Icon,
  title,
  subtitle,
  iconClassName = 'w-4 h-4 text-white',
  titleClassName = 'text-base font-semibold text-gray-900',
  subtitleClassName = 'text-xs text-gray-700',
}) => {
  return (
    <div className='mb-4'>
      <div className='flex items-center gap-2 mb-1'>
        <div className='p-1.5 rounded-md bg-primary flex items-center justify-center shadow-sm'>
          <Icon className={iconClassName} />
        </div>
        <div>
          <h3 className={titleClassName}>{title}</h3>
          {subtitle && <p className={subtitleClassName}>{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default CardTitleWithIcon;
